import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { CommonConstant } from '@utility/constants/common';
import CatalogService from '@utility/services/catalog';
import { useState } from 'react';
import { catalogKeys } from '../lib/query-keys';

export type CatalogFeed = {
  _id: string;
  createdAt?: string;
  status?: string;
  url?: string;
  results?: {
    errors?: { message?: string }[];
    messages?: { success?: string };
  };
};

const NO_FEEDS: CatalogFeed[] = [];

/** Recent item imports, a page at a time; only while `enabled`. */
export function useCatalogFeeds(state: string | undefined, enabled: boolean) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState<number>(CommonConstant.defaultPageSize);
  const params = { page, limit, feedType: 'items-import', state };

  const query = useQuery({
    queryKey: catalogKeys.feeds(params),
    queryFn: async () => {
      const result = await CatalogService.feedList(params);
      return {
        feeds: (result?.data?.feeds ?? NO_FEEDS) as CatalogFeed[],
        total: (result?.totalCount ?? 0) as number,
      };
    },
    enabled,
    placeholderData: keepPreviousData,
  });

  return {
    feeds: query.data?.feeds ?? NO_FEEDS,
    total: query.data?.total ?? 0,
    loading: query.isFetching,
    page,
    limit,
    setPage,
    setLimit: (size: number) => {
      setLimit(size);
      setPage(1);
    },
    refresh: () => void query.refetch(),
  };
}
